<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content" v-loading="loadingStaus" :element-loading-text="loadingText">
				<el-row :gutter="48">
					<el-form ref="companyForm" :disabled="formDisabled" :model="formData" :rules="rules" label-width="120px">
						<el-col :span="18">
							<el-form-item label="公司名称" prop="company_name">
								<el-input v-model="formData.company_name"></el-input>
							</el-form-item>
							<el-form-item label="纳税人识别号" prop="taxpayer">
								<el-input type="input" v-model="formData.taxpayer"></el-input>
							</el-form-item>
							<el-form-item label="地区" prop="area_code">
								<el-cascader clearable v-model="formData.area_code" :options="areaList" :props="areaProps" placeholder="请选择地区">
								</el-cascader>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<el-button v-if="!formDisabled" style="margin-left: 100px" type="primary" @click="check_company_form">下一步</el-button>
				<el-row :gutter="48" class="password-box" v-if="isShowPassword">
					<el-form ref="companyForm" :model="formData" :rules="rules" label-position="top" label-width="260px">
						<el-col :span="18">
							<el-form-item label="自然人电子税务局(扣缴端)密码" prop="password">
								<el-input v-model="formData.password" type="password" placeholder="请输入密码"></el-input>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<el-button v-if="isShowPassword" style="margin-left: 100px" type="primary" @click="check_password">开户</el-button>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import UploadFile from '@/components/UploadFile';
import uploadImg from '@/components/uploadImg';
import { mapGetters } from 'vuex';

export default {
	components: {
		PageHeaderLayout,
		UploadFile,
		uploadImg
	},
	data() {
		return {
			loadingStaus: false,
			loadingText: '正在提交中……',
			formDisabled: true,
			areaList: [],
					areaProps: {
						value: 'value',
						label: 'label',
						children: 'children',
						emitPath: false
					},
			isShowPassword: false,
			query: {},
			detail: {},
			formData: {
				company_name: '',
				area_code: '',
				taxpayer: '',
				password: ''
			},

			rules: {
				company_name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
				area_code: [{ required: true, message: '请选择地区', trigger: 'blur' }],
				taxpayer: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapGetters(['userPermissions'])
	},
	methods: {
		check_company_form() {
			// 调用组件的数据验证方法
			this.$refs['companyForm'].validate((valid) => {
				if (valid) {
					this.tax_register();
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！');
				}
			});
			return true;
		},

		// 处理编辑器内容输入
		handleTinymceInput(val) {
			this.formData.content = val;
		},
		// 初始化公司基本信息
		async init() {
			this.loadingStaus = false;
		},
		//返回上一页
		goBack() {
			this.$router.push({ path: '/customer' });
		},
		//查询账号信息
		async get_account_info() {
			const data = await this.$api.get_qxy_tax_get_account_info({
				company_name: this.query?.company_name || ''
			});
			if (data.is_register === 1) {
				this.formDisabled = true;
				this.isShowPassword = true;
			} else {
				this.formDisabled = false;
			}
			this.detail = data;
			this.formData.area_code = data.area_code;
			this.formData.taxpayer = data.taxpayer;
			this.formData.company_name = data.company_name;
			console.log(data);
		},
		//订购+注册(原型中的"下一步")
		async tax_register() {
			const data = await this.$api.get_qxy_tax_register({
				company_name: this.formData.company_name,
				area_code: this.formData.area_code,
				taxpayer: this.formData.taxpayer
			});
			if (data.is_register === 1) {
				this.formDisabled = true;
				this.isShowPassword = true;
			}
			console.log(data);
		},
		
		//检验密码
		async check_password() {
			if (!this.formData.password) {
				this.$message.error('请输入密码');
				return;
			}
			const data = await this.$api.get_qxy_tax_check_password({
				password: this.formData.password,
				company_name:this.query.company_name
			});
			// if(this.detail.is_check_pwd){
			// 	return
			// }
			this.$message.success('验证成功');
			console.log(data);
		},
		//查询地区列表
		async getArea() {
			const data = await this.$api.get_qxy_tax_get_area();
			this.areaList = data;
			console.log(data, 'datadata');
		}
	},
	async mounted() {
		this.query = this.$route.query;
	
		this.getArea();
		this.get_account_info();
		this.init();
	}
};
</script>

<style lang="scss" scoped>
.password-box {
	padding-left: 90px;
	margin-top: 24px;
}
::v-deep .el-select {
	width: 100%;
}

::v-deep .el-cascader {
	width: 100%;
}
</style>